export default ".mat-card {\n  width: 50%;\n  top: 10%;\n  margin: 0 auto 15%;\n  height: 100%;\n  max-height: 405px;\n  overflow-y: auto;\n}\n";